import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { angleBetweenPoints, distanceBetweenPoints, isMobileWidth, MOBILE_SAFE_RESIZE, } from '../globalUtils';
const PointerLine = ({ allowOpen, pointer, centerQuery, radiusMultiplier = 0.23, }) => {
    const center = useRef({ x: 0, y: 0 });
    const animationRunning = useRef(false);
    const turningLineRef = useRef(null);
    const staticLineRef = useRef(null);
    const containerRef = useRef(null);
    const readyToScrollTimeout = useRef(0);
    const setCenterBoundingRect = () => {
        let centerBounds = document
            .querySelector(centerQuery ?? '')
            ?.getBoundingClientRect();
        if (!centerQuery || !centerBounds) {
            center.current = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
        }
        else {
            const { x, y, height, width } = centerBounds;
            center.current = { x: x + width / 2, y: y + height / 2 };
        }
    };
    useEffect(() => {
        setCenterBoundingRect();
        if (allowOpen) {
            clearTimeout(readyToScrollTimeout.current);
            readyToScrollTimeout.current = window.setTimeout(stopPointerAnimation, 2350);
            startPointerAnimation();
            window.addEventListener('scroll', onScroll);
        }
        else {
            stopPointerAnimation();
        }
        window.addEventListener(MOBILE_SAFE_RESIZE, onResize);
        onResize();
        return () => {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener(MOBILE_SAFE_RESIZE, onResize);
        };
    }, [allowOpen]);
    const onScroll = () => {
        requestAnimationFrame(animFrameScroll);
    };
    const animFrameScroll = () => {
        if (allowOpen && !animationRunning.current) {
            positionPointer(true);
        }
    };
    const startPointerAnimation = () => {
        if (!animationRunning.current) {
            animationRunning.current = true;
            requestAnimationFrame(onPointer);
        }
    };
    const onPointer = () => {
        if (animationRunning.current) {
            positionPointer();
            requestAnimationFrame(onPointer);
        }
    };
    const onResize = () => {
        setTimeout(() => requestAnimationFrame(waitingPositionPointer), 10);
    };
    const waitingPositionPointer = () => positionPointer();
    const angleRef = useRef(0);
    const positionPointer = (blockCenterCalculation) => {
        if (isMobileWidth())
            return;
        if (!blockCenterCalculation) {
            setCenterBoundingRect();
        }
        if (turningLineRef.current && staticLineRef.current) {
            const containerBounds = staticLineRef.current.getBoundingClientRect();
            const { x, y, width } = containerBounds;
            const startPoint = pointer === 'left' ? { x, y } : { x: x + width, y };
            const angle = angleBetweenPoints(startPoint, center.current);
            if (angleRef.current === angle)
                return;
            angleRef.current = angle;
            const length = distanceBetweenPoints(startPoint, center.current) -
                window.innerHeight * radiusMultiplier;
            if (pointer === 'left') {
                turningLineRef.current.style.transform = `rotate(${angle}deg)`;
            }
            else {
                turningLineRef.current.style.transform = `translate(100%, 0) rotate(${angle}deg)`;
                //  scale(0.2, 1)
            }
            turningLineRef.current.setAttribute('x2', `${Math.max(length, 30)}`);
        }
    };
    const stopPointerAnimation = () => {
        animationRunning.current = false;
    };
    return (_jsx("div", { className: "pointer-line", ref: containerRef, children: _jsxs("svg", { width: "0.1", height: "0.1", className: "pointer-line-base", strokeWidth: "0.4", children: [_jsx("line", { x1: "0", y1: "0", x2: "100%", y2: "0", stroke: "var(--fontColor)", ref: staticLineRef }), _jsx("line", { x1: "0", y1: "0", x2: "100%", y2: "0", stroke: "var(--fontColor)", ref: turningLineRef })] }) }));
};
export default PointerLine;
